module.exports = __webpack_public_path__ + "static/media/night.d93df3d1.svg";